
import React from 'react';
import { Button } from '@/components/ui/button';

interface CookieBannerSimpleProps {
  onPersonalize: () => void;
  onAcceptNecessary: () => void;
  onAcceptAll: () => void;
}

export const CookieBannerSimple: React.FC<CookieBannerSimpleProps> = ({
  onPersonalize,
  onAcceptNecessary,
  onAcceptAll,
}) => {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
      <div className="flex-1">
        <h3 className="text-sm font-semibold">Nous utilisons des cookies</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Notre site utilise des cookies pour améliorer votre expérience, analyser le trafic et personnaliser le contenu.
          Vous pouvez accepter tous les cookies, les refuser ou personnaliser vos préférences.
        </p>
        <p className="text-xs text-muted-foreground mt-2">
          Votre choix sera conservé pendant 13 mois maximum.
        </p>
      </div>
      <div className="flex flex-wrap gap-2 shrink-0">
        <Button variant="outline" size="sm" onClick={onPersonalize}>
          Personnaliser
        </Button>
        <Button variant="outline" size="sm" onClick={onAcceptNecessary}>
          Refuser
        </Button>
        <Button size="sm" onClick={onAcceptAll}>
          Accepter tout
        </Button>
      </div>
    </div>
  );
};
